import { Component, OnInit } from '@angular/core';
import { PostTemplate } from '../../models/inModels/PostTemplate';
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';
import { PostTemplateService } from '../../services/post-template.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-post-template',
  templateUrl: './post-template.component.html',
  styleUrls: ['./post-template.component.css']
})
export class PostTemplateComponent implements OnInit {
  	items: PostTemplate[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
  constructor(
    private service: PostTemplateService,
		private router: Router,
		private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    	this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
  }

  changeRows(event): void {
		this.load(this.rowEvent);
	}

  
  load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
        this.loading = false;
        console.log(this.items);
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
  }

  delete(post: PostTemplate): void {
		console.log(post);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete ${post.Title}?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(post.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
  }

  edit(post: PostTemplate) {
		console.log("🚀 ~ file: post-template.component.ts:87 ~ PostTemplateComponent ~ edit ~ post:", post)
		this.router.navigate(['post-templates/edit', post.Id]);
	}

}



// WEBPACK FOOTER //
// ./src/app/components/post-template/post-template.component.ts